import { LinkProps as RadixLinkProps } from '@radix-ui/themes';

type LinkSize = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
type LinkWeight = 'light' | 'regular' | 'medium' | 'semibold' | 'bold';

export type LinkVariant = 'default' | 'ghost';

export type LinkProps = Omit<RadixLinkProps, 'color' | 'size' | 'weight'> & {
  to?: string;
  href?: string;
  weight?: LinkWeight;
  size?: LinkSize;
  variant?: LinkVariant;
  state?: Record<string, unknown>;
};

export const variantToClassNameMap: Record<LinkVariant, string | undefined> = {
  default: undefined,
  ghost: 'text-inherit no-underline hover:text-inherit hover:no-underline',
};

export const sizeToClassNameMap: Record<LinkSize, string> = {
  '1': 'text-size-fly-1',
  '2': 'text-size-fly-2',
  '3': 'text-size-fly-3',
  '4': 'text-size-fly-4',
  '5': 'text-size-fly-5',
  '6': 'text-size-fly-6',
  '7': 'text-size-fly-7',
  '8': 'text-size-fly-8',
  '9': 'text-size-fly-9',
};

export const weightToClassNameMap: Record<LinkWeight, string> = {
  light: 'font-light',
  regular: 'font-regular',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};
